import React, { useEffect, useState, useRef } from "react";
// import { useSelector } from "react-redux";

const TypeAheadFilter = ({ placeholder, typeAheadFilter, disableDarkTheme, setTypeAheadFilter }) => {
    // const { typeAheadFilter } = actionCreators;

    const [typeAheadText, setTypeAheadText] = useState("");
    const [mounted, setMounted] = useState(false);

    const typeaheadRef = useRef(null);

    // escape key acts as cancel shortcut
    const _handleKeyDown = (event) => {
        if (event.key === "Escape" && typeAheadText.length > 0) eraseInputValue();
    };

    useEffect(() => {
        setMounted(true);

        return () => {
            document.removeEventListener("keydown", _handleKeyDown);
        };
    }, []);

    useEffect(() => {
        setTypeAheadText(typeAheadFilter);
    }, [typeAheadFilter]);

    if (!mounted) {
        document.addEventListener("keydown", _handleKeyDown);
        setMounted(true);
    }

    const handleTextChange = (event) => {
        setTypeAheadText(event.target.value);
        setTypeAheadFilter(event.target.value);
        // dispatch(typeAheadFilter(event.target.value));
    };

    const eraseInputValue = () => {
        setTypeAheadFilter("");
        // dispatch(typeAheadFilter(""));
        typeaheadRef.current.value = "";
        setTypeAheadText("");
    };

    return (disableDarkTheme ?
        <div className="typeAhead lightTheme" style={{ border: "1px solid #5E6571" }}>
            <i className="material-icons" style={{ fontSize: 20 }}>search</i>
            <div>
                <input
                    type="text"
                    ref={typeaheadRef}
                    onChange={handleTextChange}
                    placeholder={placeholder}
                    autoFocus={true}
                    value={typeAheadText}
                    style={{ padding: 0 }}
                />
            </div >
            {
                typeAheadText && (
                    <button onClick={eraseInputValue} >
                        <i className="material-icons" style={{ fontSize: 20 }}>cancel</i>
                    </button>
                )}
        </div >
        :
        <>
            <div className="typeAhead">
                <div>
                    <input
                        type="text"
                        ref={typeaheadRef}
                        onChange={handleTextChange}
                        placeholder={placeholder}
                        autoFocus={true}
                        value={typeAheadText}
                    />
                </div >

                {
                    typeAheadText ? (
                        <button onClick={eraseInputValue} >
                            <i className="material-icons">cancel</i>
                        </button>
                    ) : (
                        <i className="material-icons">search</i>
                    )}
            </div >
        </>
    );
};

export default TypeAheadFilter;
